<template>
  <div class="message">
    <h3>{{ titleText }}</h3>
    <van-list
      class="vant-list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="item" v-for="item in messages" :key="item.id">
        <van-image class="item-avatar" fit="cover" round :src="iconImage" />
        <div class="info">
          <div class="info-title">{{ item.title }}</div>
          <div class="info-content" v-html="item.content"></div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { getNotificationsList } from "network/message";

export default {
  name: "Message",
  components: {},
  data() {
    return {
      messages: [],
      page: 0,
      loading: false,
      finished: false,
    };
  },
  computed: {
    titleText() {
      if (this.$route.query.type == 1) {
        return "关注信息";
      } else if (this.$route.query.type == 2) {
        return "点赞信息";
      } else if (this.$route.query.type == 3) {
        return "评论信息";
      } else {
        return "系统信息";
      }
    },
    iconImage() {
      if (this.$route.query.type == 1) {
        return require("../../assets/img/message-attent.png");
      } else if (this.$route.query.type == 2) {
        return require("../../assets/img/message-praise.png");
      } else if (this.$route.query.type == 3) {
        return require("../../assets/img/message-comment.png");
      } else {
        return require("../../assets/img/message-system.png");
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    //加载更多
    onLoad() {
      this.page++;
      getNotificationsList(this.$route.query.type, this.page).then((res) => {
        this.messages = this.messages.concat(res.data);
        if (res.data.length < 20) {
          this.finished = true;
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.message {
  background: #fff;
}
.message h3 {
  margin: 0 0px;
  padding: 20px 15px;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  color: #fff;
  background-color: var(--color-main);
}
.vant-list {
  margin: 0 20px;
}
.item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}
.item-avatar {
  margin: 10px 0;
  width: 40px;
  height: 40px;
}
.info {
  flex: 1;
  margin: 10px;
}
.info-title {
  font-size: 15px;
  font-weight: 600;
}
.info-content {
  font-size: 13px;
  color: #646566;
  white-space: pre-line;
}
</style>